<section>
  @if (pdf !== null && src) {
    <div class="view-contract pdf-iframe">
      <iframe [attr.src]="src" style="height: 100%; width:100%; border:0"></iframe>
    </div>
  }

  @if (pdf !== null) {
    <div class="text-center mt-2 mb-2">
      <a role="link" tabindex="0" class="blue-link uppercase" mdbWavesEffect id="download-contract-button"
        (click)="downloadPDF()">{{
        'MY_ACCOUNT_LOGIN.DOWNLOAD_CONTRACT' | translate }}
      </a>
    </div>
  }


  @if (pdf === null) {
    <div class="parent">
      <div class="centered-div text-center">
        <p>Sorry, the link to your Ohio Cancellation Form has expired.</p>
        <p>Please call {{branding.cs_phone_number}} for assistance.</p>
      </div>
    </div>
  }
</section>
